(ns frontend.view.data-import.view
  (:require [common.localization :as loc]
            [frontend.view.data-import.steps.advertise :as advertise]
            [frontend.view.data-import.steps.intro :as intro]
            [frontend.view.data-import.steps.errors :as errors]
            [frontend.view.data-import.steps.success :as success]
            [frontend.view.data-import.steps.uploading :as uploading]
            [frontend.view.data-import.db :refer [import-state] :as db] 
            [frontend.routing :as routing]
            [frontend.state.current-session :as session]
            [frontend.view.not-found :as not-found]
            [frontend.page-components.zap-toolbar :as zap-toolbar]
            [reagent.core :as r]
            [frontend.page-components.default-page-layout :as default-page-layout]
            [ui.components.breadcrumbs.view :as breadcrumbs]))

(defonce modal-key :data-import-modal)

(defn view [{:keys [open-time import-type]}]
  (let [open-time (cond (number? open-time) open-time
                        (number? (:open-time open-time)) (:open-time open-time)
                        :else (.getTime (js/Date.)))]
    (swap! db/import-state assoc
           :import-type import-type
           :import-step :import-step-intro
           :open-time open-time)
    (r/create-class
     {:component-did-update (fn [this _]
                              (let [props (-> this r/props)
                                    updated-open-time (:open-time props)
                                    is-open-time (:open-time @db/import-state)]
                                (when (and updated-open-time
                                           (not= (:open-time @db/import-state) updated-open-time))
                                  (swap! db/import-state assoc
                                         :import-step :import-step-intro
                                         :open-time updated-open-time))))
      :reagent-render       (fn []
                              (let [step (:import-step @import-state)]
                                (case step
                                  :import-step-advertise [advertise/view]
                                  :import-step-intro [intro/view import-state]
                                  :import-step-uploading [uploading/view]
                                  :import-step-errors [errors/view]
                                  :import-step-success [success/view]
                                  "")))})))


(defmethod routing/render-view :data-import [{:keys [route-params view-params]}]
  (let [forbidden? (or (session/is-mobile?)
                       (session/is-guest?))]
    (if forbidden?
      [not-found/not-found-view]
      [default-page-layout/view
       [:<>
        [zap-toolbar/view nil (partial zap-toolbar/back-label (loc/tr :back)) nil []]
        [view view-params]]])))

(defn breadcrumbs []
  [breadcrumbs/container
   [breadcrumbs/item
    {:on-click (fn [e]
                 (routing/set-view! [:account-settings :tab-key "data"]))}
    (loc/tr :settings/account-settings)]
   [breadcrumbs/item
    {:active? true}
    (loc/tr :settings/data-import)]])

(defmethod routing/render-view :new-settings/data-import [{:keys [route-params view-params]}]
  (let [forbidden? (or (session/is-mobile?)
                       (session/is-guest?))]
    (if forbidden?
      [not-found/not-found-view]
      [default-page-layout/view
       [:<>
        [zap-toolbar/view nil breadcrumbs nil []]
        [view view-params]]])))
